import http from './api'

const url = '/mines'
const shaftsUrl = '/shafts'

export const httpGetMines = (params) => {
  console.log("httpGetMines called with params:", params);
  return http({
    url: `${url}/`,
    method: 'GET',
    params,
  })
}

export const httpGetMine = (id) => {
  console.log("httpGetMine called with id:", id);
  return http({
    url: `${url}/${id}/`,
    method: 'GET',
  })
}

export const httpGetMineShafts = (mineId) => {
  console.log("httpGetMineShafts called with mineId:", mineId);
  return http({
    url: `${shaftsUrl}/`,
    method: 'GET',
    params: mineId ? { mine: mineId } : {},
  })
}

export const httpGetAllMineShafts = () => {
  console.log("httpGetAllMineShafts called");
  return http({
    url: `${shaftsUrl}/`,
    method: 'GET',
  })
}

export const httpGetMineShaft = (id) => {
  console.log("httpGetMineShaft called with id:", id);
  return http({
    url: `${shaftsUrl}/${id}/`,
    method: 'GET',
  })
}

export const httpCreateMine = (data) => {
  console.log("httpCreateMine called with data:", data);
  return http({
    url: `${url}/`,
    method: 'POST',
    data,
  })
}

export const httpUpdateMine = (id, data) => {
  console.log("httpUpdateMine called with id:", id, "and data:", data);
  return http({
    url: `${url}/${id}/`,
    method: 'PUT',
    data,
  })
}

export const httpDeleteMine = (id) => {
  console.log("httpDeleteMine called with id:", id);
  return http({
    url: `${url}/${id}/`,
    method: 'DELETE',
  })
} 